/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */

export type HistoryInSiteMode = typeof HistoryInSiteMode[keyof typeof HistoryInSiteMode];


export const HistoryInSiteMode = {
  avg: 'avg',
  each: 'each',
  both: 'both',
} as const;
